<template>
<div id="app">
    <main>
        <router-view></router-view>
    </main>
</div>
</template>

<script>
export default {
    name: 'app',
}
</script>

<style>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~bootstrap/dist/css/bootstrap.min.css";
@import "~font-awesome/css/font-awesome.min.css";
@import url('https://fonts.googleapis.com/css?family=Merriweather|Open+Sans');

#app {
    font-family: 'Open Sans';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    margin-bottom: 2rem;
}

main {
    /* font-size: 1.2rem; */
}

h1,
h2 {
    color: #004d90;
    font-family: 'Merriweather';
    text-align: center;
}

h1 {
    font-size: 3rem;
}

h2 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
}

h3 {
    font-size: 1.4rem;
}

p {
    /* line-height: 2.5rem; */
}

.jumbotron {
    padding: 1rem 0;
    margin-bottom: 0;
}

.btn-secondary {
    color: black;
    border-color: transparent;
}
</style>
